import React, { useState, useEffect } from "react";
import styles from "../style.module.css";
import Icon_L from "../../../assets/images/Icon_L.svg";

import signEdit from "../../../assets/images/signEdit.svg";
import signDelete from "../../../assets/images/signDelete.svg";
import { Toaster } from "react-hot-toast";
import { setAccountOpeningStep } from "../../../redux/accountOpening";
import { getLocalStorageItem } from "../../../utils/localStorage";
import { useDispatch } from "react-redux";
import axios from "axios";
import { baseBusinessUrl } from "../../../utils/baseUrl";
import CoperateAccountPopUp from "../../../Components/coperateAccountPopUp";
import { encryptRequest } from "../../../utils/encryption";
import { statesInNigeria } from "../../../utils/constants";

export default function CompanyDetailsForm({
  signEditFunction,
  deleteEditExtraFunction,
  deleteEditFunction,
  openSignatory,
  openExtraSigntory,
  taxOfficeName,
  completeCompanyDetails,
  businessName,
  setBusinessName,
  businessRegistrationNumber,
  setBusinessRegistrationNumber,
  streetnumber,
  setStreetNumber,
  streetname,
  setStreetName,
  busStop,
  setBusStop,
  area,
  setArea,
  fullAddress,
  businessPhoneNumber,
  setBusinessPhoneNumber,
  dateOfIncorporation,
  setDateOfIncorporation,
  vendorCode,
  setVendorCode,
  referralCode,
  setReferralCode,
  updating,
  extraSignatoryAdded,
  signatoryadded,
  signLastName,
  signMiddleName,
  signFirstName,
  allDirectors,
  setAllDirectors,
  tin,
  openDirectorSignatory,
  signExtraFirstName,
  signExtraMiddleName,
  signExtraLastName,
  socialMediaType,
  handleSocialChange,
  socialMediaHandle,
  setSocialMediaHandle
}) {
  const dispatch = useDispatch();
  const [intialPopup, setInitialPopup] = useState(true)

  const [userDetails, setUserDetails] = useState(
    getLocalStorageItem("userDetails")
  );

  const handleKeyPress = (event) => {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault(); // Prevent input of non-numeric characters
    }
  };

  const [single, setSingle] = useState(true);
  const [multiple, setMultiple] = useState(false);

  const clickSingle = () => {
    setSingle(true);
    setMultiple(false);
  };

  const clickMultiple = () => {
    setSingle(false);
    setMultiple(true);
  };

  const getAllDirectors = () => {
    axios
      .get(
        `${baseBusinessUrl}CompanyDirector/CompanyDirectorGetAllDetails?Tin=${encodeURIComponent(encryptRequest(tin) as string)}`
      )
      .then((response) => {
        setAllDirectors(response.data);
      })
      .catch((err) => {
        
      });
  };
  useEffect(() => {
    getAllDirectors();
  }, []);

  return (
    <div>
      {intialPopup && (<CoperateAccountPopUp setInitialPopup={setInitialPopup} />)}
      <div className="card-body">
        <h4 className="card-title text-center pl-3 mt-4">Update details</h4>
        <p className="text-center pl-5 no-wrap">
          Hello{" "}
          <span className="font-weight-bold">
            <b>{businessName}</b>{" "}
          </span>
          welcome to Alternative Bank
        </p>
        <div className="bvn_val mb-4" id="fader">
          <img src={Icon_L} alt="" />
          <small className="sterling-grey-text ml-4 font-weight-bold">
            <b>Update your address if it has changed</b>
          </small>
        </div>
        <div className="form-group mb-4">
          <label htmlFor="streetname" className="label_text">
            Account name   <sup style={{color: "red"}}>
                                          <b>**</b>
                                        </sup>
          </label>
          <input
            value={businessName}
            onChange={(e) => setBusinessName(e.target.value)}
            type="text"
            className="form-control bg-white border-dark"
            placeholder="Enter account name"
          />
        </div>

        <div className="row"></div>
        <label
          htmlFor="residentialaddress"
          className="label_text my-2 mt-4 font-weight-bold"
        >
          <b>Business address   <sup style={{color: "red"}}>
                                          <b>**</b>
                                        </sup></b>
        </label>

        <div className="row">
          <div className="col sec">
            <div className="row form-row mb-3">
              <div className="col-lg-6 mr-2">
                <label className="label_text">House number   <sup style={{color: "red"}}>
                                          <b>**</b>
                                        </sup></label>
                <input
                  onChange={(e) => setStreetNumber(e.target.value)}
                  value={streetnumber}
                  type="text"
                  onKeyPress={handleKeyPress}
                  className="form-control bg-white border-dark"
                  placeholder="Enter street number"
                />
              </div>
              <div className="col-lg-6">
                <label className="label_text">Street name   <sup style={{color: "red"}}>
                                          <b>**</b>
                                        </sup></label>
                <input
                  value={streetname}
                  onChange={(e) => setStreetName(e.target.value)}
                  type="text"
                  className="form-control bg-white border-dark"
                  placeholder="Enter street name"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col sec">
            <div className="row form-row mb-3">
              <div className=" mr-2">
                <label className="label_text">
                  Business Registration Number (RCN/BRN)   <sup style={{color: "red"}}>
                                          <b>**</b>
                                        </sup>
                </label>
                <input
                  onChange={(e) =>
                    setBusinessRegistrationNumber(e.target.value)
                  }
                  value={businessRegistrationNumber}
                  type="text"
                  className="form-control bg-white border-dark"
                  placeholder="RC1234567"
                />
              </div>
              <div className="">
                <label className="label_text">
                  Date of Incorporation   <sup style={{color: "red"}}>
                                          <b>**</b>
                                        </sup>
                </label>
                <input
                  value={dateOfIncorporation}
                  onChange={(e) => {
                    setDateOfIncorporation(e.target.value);
                  }}
                  type="text"
                  className="form-control bg-white border-dark"
                  placeholder="dd/MM/YYYY"
                />
                {/* <DatePicker
                                selected={dateOfIncorporation}
                                onChange={(date: Date) =>
                                  setDateOfIncorporation(date)
                                }
                                customInput={<ExampleCustomInput />}
                              /> */}
              </div>
            </div>
          </div>
        </div>

        <div className="form-group mb-4">
          <label htmlFor="streetname" className="label_text">
            Nearest bus-top/landmark   <sup style={{color: "red"}}>
                                          <b>**</b>
                                        </sup>
          </label>
          <input
            onChange={(e) => setBusStop(e.target.value)}
            value={busStop}
            type="text"
            className="form-control bg-white border-dark"
            placeholder="Enter nearest bus stop"
          />
        </div>
        <div className="form-group mb-4">
          <label htmlFor="streetname" className="label_text">
            Business Phone Number   <sup style={{color: "red"}}>
                                          <b>**</b>
                                        </sup>
          </label>
          <input
            onChange={(e) => setBusinessPhoneNumber(e.target.value)}
            value={businessPhoneNumber}
            type="text"
            className="form-control bg-white border-dark"
            placeholder="Enter nearest business phone number"
          />
        </div>

        <div className="form-group mb-4">
          <label htmlFor="housenumber" className="label_text">
            Area/State   <sup style={{color: "red"}}>
                                          <b>**</b>
                                        </sup>
          </label>
          {/* <input
            name="areaState"
            onChange={(e) => setArea(e.target.value)}
            value={area}
            type="text"
            className="form-control bg-white border-dark"
            placeholder="Enter Area/State"
          /> */}

<select
                      name="areaState"
                      onChange={(e) => setArea(e.target.value)}
                      value={area}
                  
                    className="form-control border-dark"
                    style={{
                      padding: "13px",
                    }}
                  >
                    <option value="">Select state</option>
                    {statesInNigeria.map((state: any) => {
                      return (
                        <option key={state.name} value={state.name}>
                          {state.name}
                        </option>
                      );
                    })}
                  </select>
        </div>

        <div className="form-group mb-4">
          <input
            name="address"
            value={fullAddress}
            className="form-control sec border-dark"
            type="text"
            placeholder="Enter full address"
          />
          <br />
        </div>
        <label htmlFor="">Do you want to add signatories?</label>
        <hr />
        <div className="form-group">
          <label htmlFor="idcardtype" className="label_text">
            Select count of signatory
          </label>

          <div className="identity-tab">
            <div className={styles.flex}>
              <p
                onClick={clickSingle}
                className={`${single ? `${styles.active}` : ""}`}
              >
                Single signatory
              </p>
              <p
                onClick={clickMultiple}
                className={`${multiple ? `${styles.active}` : ""}`}
              >
                Multiple signatory
              </p>
            </div>
          </div>
          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane show fade active"
              id="pills-int"
              role="tabpanel"
              aria-labelledby="pills-int-tab"
            >
              {signatoryadded && (
                <div className={styles.styleAddedPlaces}>
                  <div className={styles.firstSignatoryPlace}>
                    <br />
                    <p>
                      {`${signFirstName} ${" "} ${signMiddleName} ${" "} ${signLastName}`}
                    </p>
                  </div>
                  <div className={styles.iconSignatory}>
                    <img src={signEdit} alt="" onClick={signEditFunction} />
                    <img src={signDelete} alt="" onClick={deleteEditFunction} />
                  </div>
                </div>
              )}
              {extraSignatoryAdded && (
                <div className={styles.styleAddedPlaces}>
                  <div
                    className={styles.firstSignatoryPlace}
                    style={{ marginTop: "10px" }}
                  >
                    <p>
                      {`${signExtraFirstName} ${" "} ${signExtraMiddleName} ${" "} ${signExtraLastName}`}
                    </p>
                  </div>
                  <div className={styles.iconSignatory}>
                    <img src={signEdit} alt="" onClick={signEditFunction} />
                    <img
                      src={signDelete}
                      alt=""
                      onClick={deleteEditExtraFunction}
                    />
                  </div>
                </div>
              )}
              {!signatoryadded && (
                <p
                  className={styles.sign}
                  onClick={openSignatory}
                  style={{ cursor: "pointer" }}
                >
                  click to add signatory
                </p>
              )}
              {multiple && signatoryadded ? (
                <>
                  <hr className={styles.hr} />
                  <br />
                  <p
                    className={styles.sign}
                    onClick={openExtraSigntory}
                    style={{ cursor: "pointer" }}
                  >
                    click to add signatory
                  </p>
                  <br />
                </>
              ) : null}
            </div>
          </div>
        </div>
        <hr className={styles.hr} />
        <div className={styles.theDirectorAdded}>
          <label htmlFor="idcardtype" className="label_text">
            Do you want to add directors?
          </label>
          <br />
          <br />
          <hr />
          {allDirectors.map((director) => {
            return (
              <>
                <div className={styles.addedTask}>
                  <div className={styles.firstCon}>
                    <p className={styles.id}>{director.id}</p>
                    <div
                      className={styles.director}
                    >{`${director.firstName} ${director.secondName} ${director.lastName}`}</div>
                  </div>
                  <div className={styles.secondCon}>
                    <img src={signEdit} alt="" />
                    <img src={signDelete} alt="" />
                  </div>
                </div>
                <hr />
              </>
            );
          })}
          <p
            className={styles.sign}
            onClick={openDirectorSignatory}
            style={{ cursor: "pointer" }}
          >
            Click to add directors
          </p>
        </div>


        <div className="row" style={{ marginTop: "40px" }}>
          <div className="col sec">
            <div className="row form-row mb-3">
              <div className="col-lg-6 mr-2">
                <label className="label_text">
                  Social media type
                </label>
                <select
                  name="social"
                  value={socialMediaType}
                  onChange={handleSocialChange}
                  className="form-control bvn_inpu border-dark"
                  style={{ marginRight: "10px" }}
                >
                  <option key="" value="">Choose</option>
                  <option key={"instagram"} value={"instagram"}>Instagram</option>
                  <option key={"facebook"} value={"facebook"}>facebook</option>
                  <option key={"twitter"} value={"twitter"}>Twitter (x)</option>
                </select>
              </div>
              <div className="col-lg-6">
                <label className="label_text">
                  Enter social link/ handle
                </label>
                <input
                  value={socialMediaHandle}
                  onChange={(e) => {
                    setSocialMediaHandle(e.target.value);
                  }}
                  type="text"
                  className="form-control bg-white border-dark"
                  placeholder="@easynote23"
                />
                {/* <DatePicker
                                selected={dateOfIncorporation}
                                onChange={(date: Date) =>
                                  setDateOfIncorporation(date)
                                }
                                customInput={<ExampleCustomInput />}
                              /> */}
              </div>
            </div>
          </div>
        </div>

        <hr className={styles.hr} />
        <div className="row" style={{ marginTop: "20px" }}>
          <div className="col sec">
            <div className="row form-row mb-3">
              <div className="col-lg-6 mr-2">
                <label className="label_text">Vendor code (Optional)</label>
                <input
                  onChange={(e) => setVendorCode(e.target.value)}
                  value={vendorCode}
                  type="text"
                  className="form-control bg-white border-dark"
                  placeholder="Enter vendor code"
                />
              </div>
              <div className="col-lg-6">
                <label className="label_text">Referral code (Optional)</label>
                <input
                  onChange={(e) => setReferralCode(e.target.value)}
                  value={referralCode}
                  type="text"
                  className="form-control bg-white border-dark"
                  placeholder="Enter referral code"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end mt-4">
          <button
            style={{ marginRight: "10px" }}
            className="btn btn-outline-danger mr-3 btn-filled-white"
            onClick={() => dispatch(setAccountOpeningStep("tin-validation"))}
          >
            Previous
          </button>

          {
            //businessName.length < 1 ||
            // !signatoryadded ||
            // businessRegistrationNumber.length < 1 ||
            // streetname.length < 1 ||
            // streetnumber.length < 1 ||
            // busStop.length < 1 ||
            // businessPhoneNumber.length < 1 ||
            businessName?.length < 1 ? (
              <button className={styles.submit}>Proceed</button>
            ) : (
              <>
                {updating ? (
                  <div className="spinner-border text-gold" role="status">
                    <span className="sr-only"></span>
                  </div>
                ) : (
                  <button
                    type="submit"
                    className="btn btn-danger btn-filled-red"
                    onClick={completeCompanyDetails}
                  >
                    Proceed
                  </button>
                )}
              </>
            )
          }
        </div>
      </div>
    </div>
  );
}
